import { Price, AuctionTypeEnum, SellingTypeEnum, CategoryEnum } from '@classifieds-sell/datalayer';

export const getListingPrice = (
  categoryId: CategoryEnum,
  draftData: any
): number | null => {

  switch (categoryId) {
    case CategoryEnum.boatsAndMarineMotorboats: {
      const sellingType = draftData.listingDetails.sellingType;
      if (sellingType === SellingTypeEnum.classified) {
        return draftData.listingDetails.askingPrice;
      } else {
        if (draftData.listingDetails.auctionType === AuctionTypeEnum.auctionAndBuyNow) {
          return draftData.listingDetails.reservePrice ?? draftData.listingDetails.startPrice;
        } else {
          return draftData.listingDetails.buyNowPrice;
        }
      }
    }
    default:
      return 0;
  }
};

export const getPackagePrice = (
    prices: Price[],
    listingPrice: number | null
): number => {
    if (!listingPrice) {
      return prices.find(
        (price: { minValue: number; maxValue: number; price: number }) =>
          price.maxValue === null
      ).price;
    }

    return prices.find(
      (price: { minValue: number; maxValue: number; price: number }) =>
        (price.minValue <= listingPrice &&
          price.maxValue >= listingPrice) ||
        (price.minValue <= listingPrice && price.maxValue === null)
    ).price;
};
